import React from 'react'

const featuresContext = React.createContext<string[]>([])
export default featuresContext
